(() => {
  const rankProducts = (priority, experience, available) => {
    const handles = ['kumo','kaine','marron','momo','yura'];
    const scores = Object.fromEntries(handles.map((key, index) => [key, 5 - index]));
    const preference = { vibration:'kumo', air:'kaine', touch:'marron', dual:'momo', multi:'yura' };
    const priorityChoice = { compact:'kumo', budget:'kumo', easy:'kaine', range:'kumo', many:'momo' };
    if (priorityChoice[priority]) scores[priorityChoice[priority]] += 20;
    if (preference[experience]) scores[preference[experience]] += 100;
    const main = preference[experience] || priorityChoice[priority] || 'kumo';
    scores[main] += 100;
    const alternative = { kumo:'marron', kaine:'momo', marron:'kumo', momo:'kaine', yura:'momo' }[main];
    scores[alternative] += 30;
    return handles.filter(key => available.includes(key)).sort((a, b) => scores[b] - scores[a]).slice(0, 2);
  };
  window.YoriaBeginnerRank = rankProducts;
  document.querySelectorAll('[data-beginner-guide]').forEach(root => {
    if (root.dataset.guideBound) return;
    root.dataset.guideBound = 'true';
    const panel = root.querySelector('[data-guide-panel]');
    const copy = JSON.parse(root.querySelector('[data-guide-copy]').textContent);
    const form = root.querySelector('[data-guide-form]');
    const questions = [...form.querySelectorAll('[data-guide-question]')];
    const questionPanel = root.querySelector('[data-guide-questions]');
    const result = root.querySelector('[data-guide-result]');
    const resultCards = root.querySelector('[data-guide-result-cards]');
    const error = root.querySelector('[data-guide-error]');
    const next = root.querySelector('[data-guide-next]');
    const back = root.querySelector('[data-guide-back]');
    const originals = [...root.querySelectorAll('.yb-cards [data-guide-product]')];
    let step = 0;
    const comparePanel = root.querySelector('.yb-compare');
    const guideButton = root.querySelector('.yb-hero-actions [data-guide-start]');
    const compareButton = root.querySelector('[data-guide-compare-button]');
    const showMode = mode => {
      const choosing = mode === 'guide';
      panel.hidden = !choosing;
      comparePanel.hidden = choosing;
      guideButton.classList.toggle('is-selected', choosing);
      compareButton.classList.toggle('is-selected', !choosing);
      guideButton.setAttribute('aria-expanded', String(choosing));
      compareButton.setAttribute('aria-expanded', String(!choosing));
      if (!choosing) selectCategory(compareIndex);
    };
    const tracks = [...root.querySelectorAll('[data-compare-track]')];
    const categories = [...root.querySelectorAll('[data-compare-category]')];
    let compareIndex = 0;
    const selectCategory = (index, source) => {
      compareIndex = index;
      categories.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.compareCategory) === index)));
      tracks.forEach(track => { if (track !== source) track.scrollLeft = index * track.clientWidth; });
    };
    categories.forEach(button => button.addEventListener('click', () => selectCategory(Number(button.dataset.compareCategory))));
    tracks.forEach(track => track.addEventListener('scroll', () => {
      if (!track.clientWidth) return;
      const index = Math.round(track.scrollLeft / track.clientWidth);
      if (index !== compareIndex) selectCategory(index, track);
    }, { passive: true }));
    window.addEventListener('resize', () => selectCategory(compareIndex));
    showMode('guide');
    questionPanel.hidden = false;
    root.querySelectorAll('a[href^="#yb-compare-"]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      showMode('compare');
      comparePanel.scrollIntoView({ block:'start', behavior:'auto' });
    }));
    const displayStep = () => {
      questions.forEach((question, index) => { question.hidden = index !== step; });
      root.querySelector('[data-guide-step]').textContent = String(step + 1);
      next.textContent = step === 2 ? copy.result : copy.next;
      back.hidden = step === 0;
      error.hidden = true;
      questions[step].querySelector('legend').focus();
    };
    const start = () => {
      showMode('guide');
      step = 0;
      result.hidden = true;
      resultCards.replaceChildren();
      questionPanel.hidden = false;
      displayStep();
      panel.scrollIntoView({ block: 'start', behavior: 'auto' });
    };
    root.querySelectorAll('[data-guide-start], [data-guide-restart]').forEach(button => button.addEventListener('click', event => { event.preventDefault(); start(); }));
    back.addEventListener('click', () => { step = Math.max(0, step - 1); displayStep(); });
    const reassure = () => {
      const selected = [...form.querySelectorAll('[name="concern"]:checked')].map(input => input.value);
      const help = root.querySelector('[data-guide-help]');
      help.replaceChildren();
      const lines = selected.length ? selected.map(key => copy[key === 'pack' ? 'pack_help' : key + '_help']) : [copy.generic_help];
      lines.filter(Boolean).forEach(line => { const p = document.createElement('p'); p.textContent = line; help.appendChild(p); });
    };
    form.addEventListener('change', reassure);
    const buildResult = (key, index) => {
      const original = originals.find(card => card.dataset.guideProduct === 'yoria-' + key);
      const slot = document.createElement('div'); slot.className = 'yb-guide-result-slot';
      const title = document.createElement('h4'); title.textContent = index === 0 ? copy.primary : copy.secondary;
      const reason = document.createElement('p'); reason.textContent = copy['main_reason_' + key];
      const card = original.cloneNode(true);
      const idMap = new Map();
      [card, ...card.querySelectorAll('[id]')].forEach(element => {
        if (element.id) { const old = element.id; element.id = old + '-suggestion-' + index; idMap.set(old, element.id); }
      });
      card.querySelectorAll('[for], [form], [aria-describedby], [aria-labelledby]').forEach(element => {
        ['for','form','aria-describedby','aria-labelledby'].forEach(attribute => {
          const value = element.getAttribute(attribute);
          if (value) element.setAttribute(attribute, value.split(' ').map(id => idMap.get(id) || id).join(' '));
        });
      });
      [card, ...card.querySelectorAll('[data-shopify-editor-block]')].forEach(element => element.removeAttribute('data-shopify-editor-block'));
      slot.append(title, reason, card); resultCards.appendChild(slot);
    };
    form.addEventListener('submit', event => {
      event.preventDefault();
      const priority = form.querySelector('[name="priority"]:checked')?.value;
      const experience = form.querySelector('[name="experience"]:checked')?.value;
      if ((step === 1 && !priority) || (step === 2 && !experience)) { error.hidden = false; return; }
      if (step < 2) { step += 1; displayStep(); return; }
      const available = originals.filter(card => card.dataset.available === 'true').map(card => card.dataset.guideProduct.replace('yoria-', ''));
      const picks = rankProducts(priority, experience, available);
      if (!picks.length) { showMode('compare'); comparePanel.scrollIntoView(); return; }
      resultCards.replaceChildren(); picks.forEach(buildResult);
      questionPanel.hidden = true; result.hidden = false;
      result.querySelector('h3').focus();
      result.scrollIntoView({ block:'start', behavior:'auto' });
      root.dispatchEvent(new CustomEvent('yoria:guide-complete', { bubbles:true }));
    });
    root.addEventListener('change', event => {
      const input = event.target.closest('[data-product-variant-input]');
      if (!input) return;
      const card = input.closest('.yb-card');
      const price = card.querySelector('.yb-price .yoria-price');
      const sale = price?.querySelector('.yoria-price__sale');
      const compare = price?.querySelector('.yoria-price__compare');
      if (sale && price.classList.contains('yoria-price--campaign')) {
        sale.textContent = input.dataset.campaignPrice;
        if (compare) compare.textContent = input.dataset.price;
      } else if (price) {
        const span = price.querySelector('span');
        if (span) span.textContent = input.dataset.price;
      }
    });
    root.addEventListener('submit', async event => {
      const addForm = event.target.closest('.yb-add-form');
      if (!addForm || event.defaultPrevented) return;
      event.preventDefault();
      if (!addForm.reportValidity()) return;
      const button = addForm.querySelector('button[type="submit"]');
      if (button.disabled) return;
      const label = button.textContent;
      const status = addForm.closest('.yb-card').querySelector('.yb-cart-message');
      button.disabled = true; button.setAttribute('aria-busy','true'); button.textContent = copy.adding;
      status.replaceChildren();
      try {
        if (window.YoriaCampaign) { try { await window.YoriaCampaign.ensure(); } catch {} }
        const base = window.Shopify?.routes?.root || '/';
        const response = await fetch(base + 'cart/add.js', { method:'POST', credentials:'same-origin', headers:{ Accept:'application/json' }, body:new FormData(addForm) });
        if (!response.ok) throw new Error('Could not add product');
        await response.json();
        const message = document.createElement('span'); message.textContent = copy.added;
        const link = document.createElement('a'); link.textContent = copy.cart;
        link.href = window.YoriaCampaign ? window.YoriaCampaign.discountUrl(copy.cart_url) : copy.cart_url;
        status.append(message, link);
      } catch { status.textContent = copy.error; }
      finally { button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = label; }
    });
  });
})();

